<template>
  <div class="models">
    <div class="header" v-if="loading">
        <h2>Loading Model...</h2>
    </div>
    <div class="header" v-else-if="building">
        <h2>Building Model...</h2>
    </div>
    <div class="header" v-else-if="!loading">
        <h2>{{ model.name }}</h2>
    </div>

    <div class="options" v-if="loading">
        <loader></loader>
    </div>

    <div class="options" v-else>
        <div class="next">
            <button class="empty" @click="$router.push('/models')">Back</button>
        </div>

        <div class="options">
            <div class="card">
                <h3>Model Summary</h3>
                <p>Model Type: <span>{{ model.analyzer_type.toUpperCase() }}</span></p>
                <p>Status: {{ model.status === 'active' ? 'Running' : 'Stopped' }}</p>
                <p>Created: {{ new Date(model.created_at).toLocaleDateString('nl-NL') }}</p>
                <button class="danger" @click="destroy">Destroy</button>
            </div>
            <Chat :model="model" />
        </div>
    </div>
  </div>
</template>

<script>
import config from '../config';

import Chat from './Chat.vue';
import Loader from './Loader.vue';

export default {
    name: 'Models',
    components: {
        Chat,
        Loader
    },
    data () {
        return {
            model: undefined,
            loading: true,
            building: false
        }
    },
    methods: {
        destroy() {
            if (!confirm('Are you sure you want to destroy this model?')) {
                return;
            }

            const id = this.$route.params.id;
            const token = localStorage.getItem('token');

            this.loading = true;

            fetch(config.api + '/models/' + id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then(() => {
                this.notificationController.addNotification({ type: 'success', title: 'Model destroyed', message: 'Model has been destroyed.', duration: 3000 });
                this.loading = false;
                this.$router.push('/models');
            })
            .catch(error => {
                if (error.message === '403') {
                    this.$router.push('/login');
                    return;
                }
                this.notificationController.addNotification({ type: 'error', title: 'Model not found', message: 'Model could not be found.', duration: 3000 });
                this.loading = false;
                this.$router.push('/models');
            })
        },
        getModels() {
            const id = this.$route.params.id;
            const token = localStorage.getItem('token');

            this.loading = true;

            fetch(config.api + '/models/' + id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then(data => {
                this.model = data;

                if (this.model.status === 'building') {
                    this.building = true;
                    setTimeout(() => {
                        this.getModels();
                    }, 5000);
                }
                else {
                    this.building = false;
                    this.loading = false;
                }
            })
            .catch(error => {
                if (error.message === '403') {
                    this.$router.push('/login');
                    return;
                }
                this.notificationController.addNotification({ type: 'error', title: 'Model not found', message: 'Model could not be found.', duration: 3000 });
                this.loading = false;
                this.$router.push('/models');
            })
        }
    },
    computed: {
    },
    mounted() {
        this.getModels();
    }
}
</script>

<style scoped>

.rows {
    width: 900px;
}

.row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    padding: 10px 20px;
    margin: 10px 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    transition: 200ms;
    color: rgb(122, 122, 122);
    user-select: none;
    font-size: 14px;
}

.action {
    cursor: pointer;
}

.action:hover {
    background-color: rgb(240, 240, 240);
    transition: 200ms;
    cursor: pointer;
}

.action:active {
    background-color: rgb(230, 230, 230);
    transition: 200ms;
    box-shadow: none;
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    animation: loading 2s linear infinite;
}

@keyframes loading {
    0% {
        background-color: rgb(240, 240, 240);
    }
    50% {
        background-color: rgb(216, 216, 216);
    }
    100% {
        background-color: rgb(240, 240, 240);
    }

}

</style>


// WEBPACK FOOTER //
// src/components/Model.vue